// import $ from 'jquery';
import Datatable from './entities/Datatable.js';

// Add init function that is executed on every page/fragment render
mpro.addInitStatic(($container) => {

	// Init the datatable factory
	Datatable.factoryInit($container);
});

export default mpro;